import React from 'react';
import { useLocation } from 'react-router-dom';
import OracleCardCollection from '../../components/oracle/OracleCardCollection';

const OracleCardCollectionPage = ({ lang = 'es'}) => {
  const location = useLocation();
    
  // Analizamos los parámetros de la URL (?ids=1,2,3&title=Leyes)
  const queryParams = new URLSearchParams(location.search);

  // Extraemos los IDs: los convertimos de "1,2,3" a [1, 2, 3]
  const idsRaw = queryParams.get('ids');
  const cardIds = idsRaw 
    ? idsRaw.split(',').map(id => id.trim())
    : [];

  return (
    <div className="bg-gray-900 min-h-screen pt-16">
      {cardIds.length > 0 ? (
        <OracleCardCollection 
          lang={lang} 
          cardIds={cardIds} 
        />
      ) : (
        <div className="text-white text-center mt-20">
          {lang === 'es' ? 'No se encontraron cartas en esta colección.' : 'No cards found in this collection.'}
        </div>
      )}
    </div>
  );
};

export default OracleCardCollectionPage;